import { AppointmentTrainerState } from './types';

export const state = (): AppointmentTrainerState => initialState();

export const initialState = (): AppointmentTrainerState => ({
  appointmentTrainers: {
    items: [],
    isLoading: false,
    total: 2,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['CourseName', 'LocationName', 'RoomName'],
    },
  },
});
